export default class ControlDto {
  switchId: any[];
  controlModl: number = 0; //控制类型：与数据字典一致，79：下发定时；45：开；46：关
  areaId: number;
  controlRang: number = 0; //控制范围：0：已选择的设备；1：同一区域内的所有设备；2：有权限的所有设备；
  isAll: boolean;//是否全部
  paramsId: any[];//参数
  mobile: string;//手机
  switchNo: string;
  primaryTenantId: number;//原始租户Id
  targetTenantId: number;//目标租户Id
  userId: any[];//需要处理的用户id
  userName: string;//已选择的用户名称
}